export const SORT_OPTIONS = {
  latest: "Latest",
  trending: "Trending",
  "price-lh": "Price: Low to High",
  "price-hl": "Price: High to Low",
};

export const COLLECTIONS = {
  CATEGORIES: "categories",
};

export const GENDER = {
  MENS: "Mens",
  WOMEN: "Women",
};

export const COLOR_CATEGORIES = {
  Black: [
    "Black",
    "Off Black",
    "Raw Graphite",
    "Noir",
    "Black/Silver",
    "Shiny Black/Smoke",
    "Black Iron/Grey",
    "Washed Black",
    "Black Natural",
    "Black/White",
    "Black/Grey",
    "Black/Milk"
  ],
  Grey: [
    "Pale Grey",
    "Light Grey",
    "Anthracite",
    "Dust",
    "Ash",
    "Silver",
    "Grey Metal",
    "Washed Black",
    "Gray",
    "Light Gray",
    "Warm Grey",
    "Grey",
    "Pewter",
    "Chalk",
    "Black Iron/Grey",
    "Sage",
    "Metal",
    "Raw Graphite",
  ],
  Blue: [
    "Ink",
    "Peacock",
    "NAVY",
    "Washed Denim",
    "Blue Washed",
    "Blue",
    "Faded Night",
    "White / Blue",
    "Ultramarine",
    "Pale Blue",
    "Navy/White",
    "Turquoise",
    "Light Blue",
    "Royal Blue",
    "Sky Blue",
    "Iodine",
    "Light Indigo",
    "Indigo",
    "Blue Cream",
    "Blue/Black",
    "Marine",
    "Florence",
    "Aruba",
    "Limon with Cerulean",
    "Montreal",
    "St Barths",
    "Teal",
    "Cobalt",
    "Vert Amande",
    "Noir/Bleu",
    "Ciel",
    "Marine Blue",
    "Blue Bird",
    "Aqua",
    "Capri Blue",
    "Multi Blue",
    "Navy Checks",
    "Vintage Blue",
    "Dark Blue",
    "Indigo",
    "Electic Blue",
    "Celadon",
    "Scenic Route",
    "Limited Edition",
    "Navy",
    "Navy / Ivory",
    "Blue/Black"
  ],
  Purple: [
    "Purple",
    "Lilac",
    "Dark Orchid",
    "Amethyst",
  ],
  Pink: [
    "Rosewood",
    "Pink",
    "Fushcia",
    "Pale Pink",
    "Flamingo",
    "Cipria",
    "Pale Capucine",
    "Light Orchid",
    "Rosa",
    "Coral"
  ],
  Orange: [
    "Orange",
    "Pale Orange"
  ],
  Red: [
    "Red",
    "Oxblood",
    "Ruby Rose",
    "Multi / Red"
  ],
  Brown: [
    "Sabbia",
    "Beige",
    "Brown",
    "Brown / Hazel / Legend Ink",
    "Sable",
    "Dark Sand",
    "Bronze",
    "Tan",
    "Army",
    "Moss",
    "Oatmeal",
    "Light Beige",
    "Canvas",
    "Tawny",
    "Praline",
    "Camel",
    "Nude",
    "Chocolate",
    "Fango",
    "Brown / Green Acetate",
    "Kaki",
    "Khaki",
    "Neon Yellow",
    "Yellow / Brown",
    "Bottle"
  ],
  Yellow: [
    "Yellow",
    "Canyon",
    "Honey",
    "Ecru",
    "Fango",
    "Neon Yellow",
    "Yellow / Brown",
    "Sage",
    "Green Night / Solar Yellow / White",
    "Neon Yellow",
    "Sunbeam",
    "Champagne",
    "Custard"
  ],
  Green: [
    "Brown / Green Acetate",
    "Army",
    "Olive",
    "Light Green",
    "Acetate",
    "Green",
    "Green Night / Solar Yellow / White",
    "Lime",
    "Mint Green",
    "Ivory, White / Cerulean / Caterpillar",
    "Limon",
    "Limon with Cerulean",
    "Emerald",
    "Salvia",
    "Cool Mint",
    "Neon Green",
    "Cool Mint"
  ],
  White: [
    "White",
    "Milk",
    "Parchment",
    "Creme",
    "Canvas",
    "Natural",
    "Heritage White",
    "Ivory",
    "White/Mix",
    "Pearl / White",
    "Off White",
    "Vintage Blanc",
    "Arctic",
    "Skittles",
    "Bone",
    "Ecru",
    "Gesso",
    "Vintage White",
    "White / Black",
    "White/Red",
    "Angora",
    "Ivory, White / Cerulean / Caterpillar",
    "White / Multi",
    "Cream",
    "Black/Milk",
    "Off White",
    "White/Black",
    "Blanc"
  ],
  Other: [
    "Khaki",
    "Dessin",
    "Other",
    "Multi",
    "Gold",
    "Rose Gold",
    "Gold Napa Silk"
  ],
};
